var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-click=\"$event.stopPropagation()\" class=\"c-modal is-active\"><div class=\"c-modal__header\">{{ 'requestAccessToGameDeveloper' | translate }}</div><div class=\"c-modal__body\"><ui-select ng-model=\"vm.selected\" class=\"c-select c-select--uiselect\"><ui-select-match placeholder=\"{{ 'selectGameDeveloper' | translate }}\">{{ $select.selected.company_name }} ({{ $select.selected.id }})</ui-select-match><ui-select-choices repeat=\"dev in vm.gameDevelopers | filter: $select.search | limitTo: 50\"><span>{{ dev.company_name }} ({{ dev.id }})</span></ui-select-choices></ui-select></div><div class=\"c-modal__footer text-right\"><button ng-click=\"vm.close(false)\" class=\"o-btn c-btn c-btn--secondary\">{{ 'cancel' | translate:'{ value: \"\" }' }}</button><button ng-click=\"vm.close(vm.selected)\" ng-disabled=\"!vm.selected\" class=\"o-btn c-btn c-btn--outlined\">{{ 'send' | translate }}</button></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/admin/gameDevelopers/requestAccessModal.jade
 ** module id = 618
 ** module chunks = 0
 **/